var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('span',{staticClass:"text-20-b"},[_vm._v("Мои цели")]),_c('span',{staticClass:"all text-16-b",on:{"click":function($event){return _vm.openAllTask()}}},[_vm._v("Все")])]),_c('active-goal-block',{staticClass:"active-goal",attrs:{"goal":_vm.activeGoal},on:{"editGoal":_vm.editGoal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }